module.exports = __webpack_public_path__ + "img/banner-bg.04fd7817.png";